import {
  emailRegex,
  uppercaseCharacterRegex,
  lowercaseCharacterRegex,
  numberRegex,
  whitespaceRegex,
  specialCharacterRegex,
} from 'resources/regex'

const minLength = (minimum, fieldName) => value =>
  value && value.length >= minimum
    ? undefined
    : `${fieldName} must be at least ${minimum} characters`
const maxLength = (maximum, fieldName) => value =>
  value.length <= maximum
    ? undefined
    : `${fieldName} cannot exceed ${maximum} characters`

export const requiredField = value => (value ? undefined : 'Required')

export const requiredSelectField = value =>
  value !== 'Please Select' ? undefined : 'Required'

export const bothNames = value =>
  /\S+ +\S+/.test(value) ? undefined : 'Please enter your first and last name'

export const validCompanyName = value =>
  value.trim().length > 0 ? undefined : 'Please enter a valid company name'

export const validEmail = value =>
  value.match(emailRegex) ? undefined : 'Invalid email address'

export const usernameEmailCheck = value =>
  value.match(emailRegex) ? 'Please enter your VictorOps username' : undefined

export const phoneValidator = value => {
  const strippedPhone = value.replace(/\D/g, '')
  if (strippedPhone) {
    const isValidPhoneNumber =
      strippedPhone.length >= 7 && strippedPhone.length <= 15
    if (isValidPhoneNumber) {
      return undefined
    }
  }
  return 'Please enter a valid phone number'
}

export const passwordLength = value =>
  value && value.length >= 8 ? undefined : 'At least 8 characters'

const passwordUppercaseCharacter = value =>
  uppercaseCharacterRegex.test(value)
    ? undefined
    : 'At least 1 uppercase letter'

const passwordLowercaseCharacter = value =>
  value && lowercaseCharacterRegex.test(value)
    ? undefined
    : 'At least 1 lowercase letter'

const passwordNumberCharacter = value =>
  numberRegex.test(value) ? undefined : 'At least 1 number'

const passwordSpecialCharacter = value =>
  specialCharacterRegex.test(value) ? undefined : 'At least 1 special character'

const passwordWhitespaceCharacter = value =>
  whitespaceRegex.test(value) ? 'No whitespaces' : undefined

export const passwordValidator = value => {
  return [
    passwordLength,
    passwordUppercaseCharacter,
    passwordLowercaseCharacter,
    passwordNumberCharacter,
    passwordSpecialCharacter,
    passwordWhitespaceCharacter,
  ]
    .map(fn => fn(value))
    .filter(err => !!err)
    .join('<br/>')
}

export const nameLength = maxLength(225, 'Name')

export const userNameLength = maxLength(50, 'Username')

export const companyNameLength = maxLength(50, 'Company Name')
